"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const debug_1 = __importDefault(require("debug"));
const hunspell_asm_1 = require("hunspell-asm");
const result_1 = require("../result");
const i18n_1 = require("../i18n");
const debug = debug_1.default('hunspell-dictionary-store');
class HunspellDictionaryStore {
    constructor(loadBuffer) {
        this.loadBuffer = loadBuffer;
        this.mountedDictionaries = [];
    }
    async prepareLanguages(languages, cancel) {
        debug('prepareLanguages', languages);
        if (!this.hunspellFactory) {
            this.hunspellFactory = await hunspell_asm_1.loadModule();
        }
        if (!this.hunspellFactory) {
            throw new Error('Hunspell hasn\'t initialized, please call initialize()');
        }
        let allSuccess = true;
        for (let language of languages) {
            let loaded = this.findMountedLanguage(language);
            if (!loaded) {
                const chain = i18n_1.localeFallbackChain(language);
                const result = await i18n_1.fallbackAsync(chain, (langCode) => this.tryLoadDictionary(langCode, this.hunspellFactory, cancel));
                debug('dictionaryResult', result);
                if (result.success) {
                    this.mountedDictionaries.push(result.value);
                }
                else {
                    allSuccess = false;
                }
            }
        }
    }
    async tryLoadDictionary(language, hunspellFactory, cancel) {
        const dictionaryResult = await this.loadDictionary(language, hunspellFactory, cancel);
        debug('dictionaryResult', dictionaryResult);
        return dictionaryResult;
    }
    resolveLanguage(language) {
        debug('resolveLanguage', language, this.mountedDictionaries);
        if (!this.hunspellFactory) {
            throw new Error('Hunspell hasn\'t initialized, please call initialize()');
        }
        const chain = i18n_1.localeFallbackChain(language);
        if (chain.length === 0) {
            debug(`Invalid language code '${language}'`);
            return result_1.err('invalid-language-code');
        }
        const result = i18n_1.fallback(chain, (code) => this.tryCreateHunspell(code));
        if (result.success) {
            return result;
        }
        debug(`could not resolve dictionary`);
        return result_1.err('not-found');
    }
    tryCreateHunspell(langCode) {
        let loaded = this.findMountedLanguage(langCode);
        if (!loaded) {
            return result_1.err('not-mounted');
        }
        if (!this.hunspellFactory) {
            throw new Error('Hunspell hasn\'t initialized, please call initialize()');
        }
        debug('creating hunspell for dictionary', loaded);
        const hunspell = this.hunspellFactory.create(loaded.aff, loaded.dic);
        return result_1.ok(hunspell);
    }
    releaseLanguage(language) {
        debug('releaseLanguage', language);
        if (!this.hunspellFactory) {
            throw new Error('Hunspell hasn\'t initialized, please call initialize()');
        }
        let loaded = this.findMountedLanguage(language);
        if (loaded) {
            this.hunspellFactory.unmount(loaded.aff);
            this.hunspellFactory.unmount(loaded.dic);
        }
    }
    findMountedLanguage(language) {
        return this.mountedDictionaries.find(x => x.language === language);
    }
    async loadDictionary(language, factory, cancel) {
        debug('loadDictionary', language);
        const self = this;
        const dicPromise = mountBuffer('dic');
        const affPromise = mountBuffer('aff');
        const [dicResult, affResult] = await Promise.all([dicPromise, affPromise]);
        debug('dictionary load result', language, dicResult, affResult);
        if (!dicResult.success) {
            return dicResult;
        }
        if (!affResult.success) {
            return affResult;
        }
        return result_1.ok({
            language,
            dic: dicResult.value,
            aff: affResult.value
        });
        async function mountBuffer(extension) {
            const bufferResult = await self.loadBuffer(language, extension, cancel);
            if (!bufferResult.success) {
                return bufferResult;
            }
            const outputFilename = `${language}.${extension}`;
            const mounted = factory.mountBuffer(new Uint8Array(bufferResult.value), outputFilename);
            return result_1.ok(mounted);
        }
    }
}
exports.HunspellDictionaryStore = HunspellDictionaryStore;
//# sourceMappingURL=hunspell-dictionary-store.js.map